<template>
    <div>
        <h1 class="white--text" id="current-situation-title-text">Situação atual</h1>
        <div class="my-2">
            <v-icon color="secondary lighten-1" left size="18">mdi-select-group</v-icon> 
            <span class="white--text" id="saic-subtitle-text">SAIC</span>
        </div>
        <hr style="display: block; border: 1px solid #D9D9D9;" />
       <percentage-of-useful-volume />
    </div>
</template>

<script>
import PercentageOfUsefulVolume from './PercentageOfUsefulVolume.vue'
export default {
    name: 'CurrentSituationReservoir',
    components: { PercentageOfUsefulVolume },
    data:()=>({

    })
}
</script>

<style scoped>
    #current-situation-title-text{
        font-family: Roboto;
        font-style: normal;
        font-weight: bold;
        font-size: 20px;
        line-height: 23px;
    }

    #saic-subtitle-text{
        font-family: Roboto;
        font-style: normal;
        font-weight: normal;
        font-size: 16px;
        line-height: 20px;
    }
</style>